import { Component, forwardRef, input, signal } from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { DatePicker } from 'primeng/datepicker';

@Component({
  selector: 'app-let-date-picker',
  imports: [DatePicker, FormsModule],
  templateUrl: './let-date-picker.component.html',
  styleUrl: './let-date-picker.component.css',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LetDatePickerComponent),
      multi: true,
    },
  ],
})
export class LetDatePickerComponent implements ControlValueAccessor {
  valueSignal = signal<Date | undefined>(undefined);
  showTime = input<boolean>(false);
  isDisabled = false;
  placeholder = input<string>();

  private onChange: any = () => {
    console.log('onChange');
  };
  private onTouch: any = () => {
    console.log('onTouch');
  };

  writeValue(value: string): void {
    // Update the signal when the value changes
    if (value) {
      const dateValue = new Date(value);
      this.valueSignal.set(dateValue);
    } else {
      this.valueSignal.set(undefined);
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  onValueChange(newValue: Date): void {
    if (newValue instanceof Date) {
      const z = newValue.getTimezoneOffset() * 60 * 1000;
      const tLocal = newValue.getTime() - z;
      const tLocalDate = new Date(tLocal);
      const isoString = tLocalDate.toISOString();
      //drop the milliseconds and zone
      const iso = isoString.split('.')[0];

      this.valueSignal.set(newValue);
      this.onChange(iso);
      this.onTouch();
    }
  }
}
